import React from "react";
import Button from "../button";
import ChatHeader from "../chat-header";
import "./search-selection-board.scss";
import { Loader } from "../../assets/images/index";

interface ValidOption {
  id: number;
  name: string;
  code: number;
}

interface SearchSelectionProps {
  pageTitle: string;
  onBackClick: () => void;
  col1Title: string;
  col2Title: string;
  col3Title: string;
  col1Items: ValidOption[];
  col2Items: ValidOption[];
  col3Items: ValidOption[];
  selectedCol1: number | null;
  selectedCol2: number | null;
  selectedCol3: number | null;
  onCol1Select: (id: number) => void;
  onCol2Select: (id: number) => void;
  onCol3Select: (id: number) => void;
  isLoading?: boolean;
  isLoadingCol1?: boolean;
  isLoadingCol2?: boolean;
  isLoadingCol3?: boolean;
  onSubmit: () => void;
  submitButtonText: string;
}

export const SearchSelectionBoard: React.FC<SearchSelectionProps> = ({
  pageTitle,
  onBackClick,
  col1Title,
  col2Title,
  col3Title,
  col1Items,
  col2Items,
  col3Items,
  selectedCol1,
  selectedCol2,
  selectedCol3,
  onCol1Select,
  onCol2Select,
  onCol3Select,
  isLoading,
  isLoadingCol1,
  isLoadingCol2,
  isLoadingCol3,
  onSubmit,
  submitButtonText,
}) => {

  const sortItems = (items: ValidOption[]) => [...items].sort((a, b) => a.code - b.code);

  return (
    <div className="search-selection-page">
      <ChatHeader chatHeading={pageTitle} onBackClick={onBackClick} />
      <div className="search-selection-body">
        <div className="search-selection-list">
          {/* Column 1 Section */}
          <div className="search-selection-list-inner">
            <div className="search-selection-list-header">
              <h6 className="search-selection-list-title">{col1Title}</h6>
              {(isLoading || isLoadingCol1) && (
                <div className="loaderBlock">
                  <img src={Loader} alt="Loader" />
                </div>
              )}
            </div>
            <div className="search-selection-list-items level-list-horizontal">
              {sortItems(col1Items).map((item) => (
                <div key={item.id} className="search-selection-list-item">
                  <input
                    type="radio"
                    id={`col1-${item.id}`}
                    name="col1"
                    value={item.id}
                    checked={selectedCol1 === item.id}
                    onChange={() => onCol1Select(item.id)}
                  />
                  <label htmlFor={`col1-${item.id}`}>{item.name}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Column 2 Section */}
          <div className="search-selection-list-inner">
            <div className="search-selection-list-header">
              <h6 className="search-selection-list-title">{col2Title}</h6>
              {(isLoading || isLoadingCol2) && (
                <div className="loaderBlock">
                  <img src={Loader} alt="Loader" />
                </div>
              )}
            </div>
            <div className="search-selection-list-items topic-list">
              {sortItems(col2Items).map((item) => (
                <div key={item.id} className="search-selection-list-item">
                  <input
                    type="radio"
                    id={`col2-${item.id}`}
                    name="col2"
                    value={item.id}
                    checked={selectedCol2 === item.id}
                    onChange={() => onCol2Select(item.id)}
                  />
                  <label htmlFor={`col2-${item.id}`}>{item.name}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Column 3 Section */}
          <div className="search-selection-list-inner">
            <div className="search-selection-list-header">
              <h6 className="search-selection-list-title">{col3Title}</h6>
              {(isLoading || isLoadingCol3) && (
                <div className="loaderBlock">
                  <img src={Loader} alt="Loader" />
                </div>
              )}
            </div>
            <div className="search-selection-list-items difficulty-list">
              {sortItems(col3Items).map((item) => (
                <div key={item.id} className="search-selection-list-item">
                  <input
                    type="radio"
                    id={`col3-${item.id}`}
                    name="col3"
                    value={item.id}
                    checked={selectedCol3 === item.id}
                    onChange={() => onCol3Select(item.id)}
                  />
                  <label htmlFor={`col3-${item.id}`}>{item.name}</label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="search-selection-button">
          <Button text={submitButtonText} color="blue" onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};
